import { get, memoize } from 'es-toolkit/compat';
import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

// @ts-ignore
var lazyKoKR = function lazyKoKR() {
  return import('../../translates/ko/common.json');
};
// @ts-ignore
var lazyEnUS = function lazyEnUS() {
  return import('../../translates/en/common.json');
};
// @ts-ignore
var lazyJaJP = function lazyJaJP() {
  return import('../../translates/ja/common.json');
};
// @ts-ignore
var lazyZhCN = function lazyZhCN() {
  return import('../../translates/zh/common.json');
};
var lazyResourceMap = {
  ko_KR: lazyKoKR,
  en_US: lazyEnUS,
  ja_JP: lazyJaJP,
  zh_CN: lazyZhCN
};
var resourceError = function resourceError() {
  return Promise.reject(new Error('not found language resource'));
};
var getResource = memoize(function (language) {
  return get(lazyResourceMap, language, resourceError)();
});
export function initializeI18n() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ko_KR';
  // session 없으면 'ko'로 넘어 옴.
  if (locale === 'ko') {
    locale = 'ko_KR';
  }
  return i18next.use(initReactI18next) // passes i18n down to react-i18next
  .use(resourcesToBackend(function (language, namespace, callback) {
    getResource(language).then(function (resources) {
      callback(null, resources.default);
    }).catch(function (error) {
      callback(error, null);
    });
  })).init({
    /**
     * IE11
     * https://stackoverflow.com/questions/70493788/i18nextpluralresolver-your-environment-seems-not-to-be-intl-api-compatible-u
     */
    compatibilityJSON: 'v3',
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    lng: locale,
    // if you're using a language detector, do not define the lng option
    fallbackLng: 'ko_KR',
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: []
    },
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    nsSeparator: false,
    returnEmptyString: false,
    /**
     * production 이나 테스트 등에서 parseMissingKeyHandler 처리 필요 (interpolation 은 처리되지 않음)
     * production 은 i18n-pull 이 선행되므로 사실상 parseMissingKeyHandler 과정이 진행되지 않음
     */
    parseMissingKeyHandler: function parseMissingKeyHandler(key) {
      return key.replace(/.+?~~/, '');
    }
  }).then(function (t) {
    // initialized and ready to go!
    return getResource(locale);
  });
}
export var i18n = i18next;